export class MaterialLibIndicator {
  total = 0
  fdes = 0
  pep = 0
}
